var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPrimevue(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 62,
    height: 71,
    viewBox: "0 0 62 71",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M45.6995 32.561L40.8887 31.4923L44.6304 36.8358V53.4007L57.4594 42.7137V24.5458L51.5795 26.6832L45.6995 32.561Z",
    fill: "#fff"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.7652 32.561L20.5761 31.4923L16.8343 36.8358V53.4007L4.00537 42.7137V24.5458L9.8853 26.6832L15.7652 32.561Z",
    fill: "#fff"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.4385 37.9046L22.7148 31.4924L25.3875 33.0955H36.0783L38.751 31.4924L43.0273 37.9046V61.9504L39.8201 66.7596L36.0783 70.5H25.3875L21.6457 66.7596L18.4385 61.9504V37.9046Z",
    fill: "#fff"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M44.6304 63.5536L51.5794 56.607V49.6605L44.6304 55.5383V63.5536Z",
    fill: "#fff"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M16.8343 63.5536L9.88525 56.607V49.6605L16.8343 55.5383V63.5536Z",
    fill: "#fff"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.7832 0.5L19.5068 10.6527L26.4558 30.958H29.6632V0.5H23.7832ZM31.8013 0.5V30.958H35.543L41.9575 10.6527L37.6812 0.5H31.8013Z",
    fill: "#fff"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M26.4561 30.9581L3.47091 22.4084L0.263672 9.04968L20.0416 10.6527L26.9906 30.9581H26.4561Z",
    fill: "#fff"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M35.5433 30.9581L58.5285 22.4084L61.7357 9.04968L41.4232 10.6527L35.0088 30.9581H35.5433Z",
    fill: "#fff"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M43.0269 9.04961L54.2523 7.98091L46.7687 0.5H39.2852L43.0269 9.04961Z",
    fill: "#fff"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M18.4377 9.04961L7.2124 7.98091L14.6959 0.5H22.1795L18.4377 9.04961Z",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPrimevue);
export default __webpack_public_path__ + "static/media/primevue.3d0728e51c81cd61efd31d078a392de5.svg";
export { ForwardRef as ReactComponent };